import React, { CSSProperties, FC } from 'react';
import { Button, Space } from 'antd';
import { Formik } from 'formik';
import { Form, Input, SubmitButton } from 'formik-antd';
import { FormikOnSubmit } from 'lib/formik.utils';
import { SearchOutlined } from '@ant-design/icons/lib';
import { useFormatMessage } from 'common/hooks/useFormatMessage';
import { FormattedMessage } from 'react-intl';
import { SubpartnersFilterSelect } from 'common/components/SubpartnersSelect';

export interface PatientsFiltersFormModel {
  login?: string;
  partner?: string;
  partnerID?: number | undefined;
}

export interface PatientsFiltersProps {
  loading?: boolean;
  value?: PatientsFiltersFormModel;
  onSubmit: FormikOnSubmit<PatientsFiltersFormModel>;
  style?: CSSProperties;
  shouldHidePartnerColumn: boolean;
}

export const AdminsFilters: FC<PatientsFiltersProps> = ({
  onSubmit,
  loading,
  value = {},
  style,
  shouldHidePartnerColumn,
}) => {
  const intlMessage = useFormatMessage();

  return (
    <Formik initialValues={value} onSubmit={onSubmit} onReset={onSubmit}>
      <Form style={style}>
        <Space style={{ marginBottom: '1rem' }}>
          <Input
            name="login"
            placeholder={intlMessage({ id: 'admins.login' })}
            style={{ width: 200 }}
          />
          {!shouldHidePartnerColumn && (
            <SubpartnersFilterSelect
              name="partnerID"
              placeholder={intlMessage({ id: 'partner' })}
              style={{ minWidth: 200, width: '100%' }}
            />
          )}
          <SubmitButton
            type="default"
            loading={loading}
            icon={<SearchOutlined />}
          >
            <FormattedMessage id="search" tagName="span" />
          </SubmitButton>
          <Button id="button-clear-admins-filter" htmlType="reset">
            <FormattedMessage id="clear" />
          </Button>
        </Space>
      </Form>
    </Formik>
  );
};
